import { Link, NavLink } from "react-router-dom";
import { Home, Layers, Settings } from "lucide-react";
import { Footer, Logo } from "@/components/Brand";
import { RuruIcon } from "@/components/RuruIcon";
import { useMe } from "@/context/MeContext";

const NAV = [
  { to: "/", label: "Home", icon: Home, id: "home" },
  { to: "/plans", label: "Plans", icon: Layers, id: "plans" },
  { to: "/explore", label: "Ako", icon: RuruIcon, id: "explore" },
  { to: "/settings", label: "Settings", icon: Settings, id: "settings" },
];

export const Header = ({ nav = true, right = null, wide = false }) => (
  <header className="sticky top-0 z-30 bg-charcoal" data-testid="app-header">
    <div className={`mx-auto flex h-16 items-center justify-between px-5 sm:px-8 ${wide ? "max-w-6xl" : "max-w-3xl"}`}>
      <a href="https://ahucoach.com" aria-label="AHU Coach website" data-testid="header-logo-link"><Logo variant="gold" testId="header-logo" /></a>
      {nav && (
        <nav className="hidden md:flex items-center gap-1" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} data-testid={`nav-${n.id}`}
              className={({ isActive }) => `rounded-full px-4 py-2 text-[15px] ${isActive ? "bg-white/10 text-alabaster" : "text-alabaster/75 hover:text-alabaster"}`}
              style={{ transition: "color .3s ease, background-color .3s ease" }}>
              {n.label}
            </NavLink>
          ))}
        </nav>
      )}
      {right}
    </div>
  </header>
);

const MobileNav = () => (
  <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-rule pb-[env(safe-area-inset-bottom)]" data-testid="mobile-nav">
    <div className="grid grid-cols-4">
      {NAV.map(({ to, label, icon: Icon, id }) => (
        <NavLink key={to} to={to} end={to === "/"} data-testid={`mobile-nav-${id}`}
          className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-xs ${isActive ? "text-charcoal font-medium" : "text-ink-soft"}`}>
          {({ isActive }) => (<><Icon size={20} strokeWidth={1.6} className={isActive ? "text-gold" : ""} />{label}</>)}
        </NavLink>
      ))}
    </div>
  </nav>
);

export default function AppShell({ children, nav: wantNav = true, wide = false }) {
  const { me } = useMe();
  const nav = wantNav && !(me && me.role !== "admin" && ["restricted", "lapsed"].includes(me.access));
  return (
    <div className="min-h-screen flex flex-col bg-alabaster">
      <Header nav={nav} wide={wide} />
      <main className={`flex-1 w-full mx-auto px-5 sm:px-8 pt-10 pb-16 ${wide ? "max-w-6xl" : "max-w-3xl"}`}>{children}</main>
      <div className={nav ? "pb-16 md:pb-0" : ""}><Footer /></div>
      {nav && <MobileNav />}
    </div>
  );
}
